import { render, staticRenderFns } from "./AnalysisToolColor.vue?vue&type=template&id=35a0d0b1&scoped=true&"
import script from "./AnalysisToolColor.vue?vue&type=script&lang=js&"
export * from "./AnalysisToolColor.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisToolColor.vue?vue&type=style&index=0&id=35a0d0b1&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a0d0b1",
  null
  
)

export default component.exports